import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'chapterTranslation'
})
export class ChapterTranslationPipe implements PipeTransform {

    constructor(private translate: TranslateService) {
    }

    transform(value: string): string {
        switch (value) {
            case 'Diagnosis':
                return this.translate.instant('GENERAL.DISEASE');
            case 'Course':
                return this.translate.instant('CONSENT.COURSE');
            case 'Treatment':
                return this.translate.instant('GENERAL.TREATMENT');
            case 'Prospects':
                return this.translate.instant('CONSENT.PROSPECTS');
            case 'Conduct':
                return this.translate.instant('CONSENT.CONDUCT');
            case 'Risks':
                return this.translate.instant('CONSENT.RISKS');
            case 'Actions':
                return this.translate.instant('CONSENT.AFTER');
        }
        return value;
    }

}
